import sanitizeObject from './sanitizeObject';

/**
 * Takes in an object and generates a query string
 * @param {*} obj object data
 */
export function toQueryString(obj) {
  return new URLSearchParams(obj).toString();
}

/**
 * Takes in a valid query string and generates an object
 * @param {*} str querystring from url
 */
export function fromQueryString(str) {
  return sanitizeObject(Object.fromEntries(new URLSearchParams(str).entries()));
}

/**
 * Takes in an object and generates a lower-cased querystring value
 * @param {*} obj object data
 */
export function normalizeQueryString(obj) {
  return toQueryString(obj).toLowerCase();
}

export function getQueryParamsFromLocation(location) {
  const query = location?.search?.substring(1);
  return query ? fromQueryString(query) : {};
}
